import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  Box,
  HStack,
  Icon,
} from "@chakra-ui/react";
import { FaBuilding, FaUser } from "react-icons/fa";
import { useModal } from "../../hooks/useModal";
import { colors } from "../../colors";
import styled from "styled-components";

const OptionCard = styled.div`
  padding: 1.5rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;

  &:hover {
    border-color: ${colors.gold};
    background: ${colors.gold}10;
    transform: translateY(-2px);
  }
`;

export const AccountTypeModal = () => {
  const { activeModal, openModal, closeModal } = useModal();

  if (activeModal !== "choose-account-type") return null;

  return (
    <Modal isOpen={true} onClose={closeModal} isCentered>
      <ModalOverlay />
      <ModalContent margin="auto" maxW="460px">
        <ModalHeader fontSize="2xl" textAlign="center" pt={8}>
          How would you like to use SkipGive?
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={8} px={8}>
          <VStack spacing={4}>
            <OptionCard onClick={() => openModal("create-organization")}>
              <HStack spacing={4} align="center">
                <Box color={colors.gold} flexShrink={0}>
                  <Icon as={FaBuilding as any} boxSize={6} />
                </Box>
                <Box>
                  <Text fontWeight="700" fontSize="lg">
                    Nonprofit Organization
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    Register your 501(c)(3) organization to raise funds directly.
                  </Text>
                </Box>
              </HStack>
            </OptionCard>

            <OptionCard onClick={() => openModal("create-individual")}>
              <HStack spacing={4} align="center">
                <Box color={colors.gold} flexShrink={0}>
                  <Icon as={FaUser as any} boxSize={6} />
                </Box>
                <Box>
                  <Text fontWeight="700" fontSize="lg">
                    Individual Fundraiser
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    Raise money on behalf of a registered 501(c)(3) nonprofit
                    organization.
                  </Text>
                </Box>
              </HStack>
            </OptionCard>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
